import {toLower} from '@servicenow/ui-internal';
import {SEISMIC_HOIST_TAG_NAME} from '../constants';

const doc = window.document;
const styleFragments = {};

/**
 * @function
 * @param {String} [style]
 * @param {Array.<String>} [stylesheetsContent]
 * @param {String} [tagName]
 * @returns {HTMLElement}
 */
export default function createStyleFragment(style, stylesheetsContent, tagName) {
	const cachedStyleFragment = styleFragments[tagName];
	if (cachedStyleFragment) return cachedStyleFragment.content.cloneNode(true);

	let styleFragment;
	const externalStylesFragment = document.head.querySelector(`#now-${toLower(tagName)}-styles`);
	if (externalStylesFragment) {
		styleFragment = mergeStylesheets(externalStylesFragment, stylesheetsContent);
	} else {
		let styles = '';
		styleFragment = doc.createElement('template');

		if (style) styles += style;

		if (stylesheetsContent) styles += stylesheetsContent;

		styleFragment.innerHTML = `<style type="text/css">${styles}</style>`;
	}

	if (tagName !== SEISMIC_HOIST_TAG_NAME) styleFragments[tagName] = styleFragment;

	return styleFragment.content.cloneNode(true);
}

function mergeStylesheets(externalStylesFragment, stylesheetsContent) {
	if (!stylesheetsContent) return externalStylesFragment;

	// this case should be rare, if ever; ideally we should deprecate support for config.stylesheets
	const externalStylesEl = externalStylesFragment.content.cloneNode(true).children[0];
	externalStylesEl.textContent = `${stylesheetsContent}\n${externalStylesEl.textContent}`;
	const mergedStyleFragment = doc.createElement('template');
	mergedStyleFragment.content.appendChild(externalStylesEl);

	return mergedStyleFragment;
}
